import { all, put, call, takeEvery } from "redux-saga/effects";
import axios from "axios";

import * as actions from "./actions";

function* loadDeliveryItemDeleteHistory(action) {
  const {
    data: {
      page,
      pageSize,
      searchName,
      companyID,
      orderBy,
      orderType,
      filterObj,
      accessToken,
      cb
    }
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/deliveryitemdeletehisory`,
      // `http://booking-api/api/deliveryitem`,
      {
        searchName,
        page,
        pageSize,
        companyID,
        orderBy,
        orderType,
        filterObj,
        accessToken,
        cb
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    cb();
    yield put(actions.loadDeliveryItemDeleteHistory.success(res.data, page));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadDeliveryItemDeleteHistory.failure());
  }
}

function* loadDeliveryItemDeleteHistoryDetail(action) {
  const {
    data: { id, accessToken },
    cb
  } = action.payload;
  // const company_id =
  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/deliveryitem/detail/${id}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    // cb(res.data[0]);
    yield put(actions.loadDeliveryItemDeleteHistoryDetail.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadDeliveryItemDeleteHistoryDetail.failure());
  }
}

export default function* watchDeliveryItemMasterDataState() {
  yield all([
    takeEvery(
      actions.LOAD_DELIVERYITEMDELETEHISTORY.REQUEST,
      loadDeliveryItemDeleteHistory
    ),
    takeEvery(
      actions.LOAD_DELIVERYITEMDELETEHISTORY_DETAIL.REQUEST,
      loadDeliveryItemDeleteHistoryDetail
    )
  ]);
}

export { loadDeliveryItemDeleteHistory, loadDeliveryItemDeleteHistoryDetail };
